import { Link } from 'react-router-dom';
import { AxiosError } from 'axios';
import { FallbackProps } from 'react-error-boundary';
import { Button, Stack, Typography } from '@mui/material';
import { RouteEnum, useSession } from 'App';
import { Header } from 'layout';

import * as S from './AccessDenied.styled';
import { SessionStatus } from 'App/session/Session.types';

type AccessDeniedPropsType = {
  error: AxiosError<{ message: string }>;
  resetErrorBoundary: FallbackProps['resetErrorBoundary'];
};

export const AxiosErrorPage = ({ error, resetErrorBoundary }: AccessDeniedPropsType) => {
  const isDenied = error.response?.status === 403;

  const { status, initialPage } = useSession();
  const to = initialPage || RouteEnum.AuditQueue;

  return (
    <>
      {status === SessionStatus.Authenticated && <Header />}
      <S.Container>
        <Typography fontWeight={600} fontSize={64}>
          {error.response?.status || ''}
        </Typography>
        <Stack alignItems='start' gap={1} maxWidth={450}>
          {
            <Typography fontSize={16} padding='6px 8px'>
              {isDenied ? (
                <>Sorry, looks like you don&apos;t have enough rights to see this page</>
              ) : (
                <>{error.response?.data?.message || error.message}</>
              )}
            </Typography>
          }
          <Link to={to} style={{ textDecoration: 'none' }} onClick={resetErrorBoundary}>
            <Button sx={{ textTransform: 'none', fontSize: 16 }}>Go back to the main page</Button>
          </Link>
        </Stack>
      </S.Container>
    </>
  );
};
